import * as React from 'react';
import { useSelector } from 'react-redux';

import { getName, getNameUrl } from './utils';
import { SubscriptionAuthorName } from '../../../components/subscriptionBrand';
import { selectAgencyName, selectAgentName } from '../../../selectors';
import { selectIsHonestIconsShow } from '../../../selectors/offerData';
import { selectAgencyUrl, selectAgentUrl, selectIsSubAgent } from '../../../selectors/offerData/agent';
import { trackGoToAgentCard } from '../SubscriptionAuthorBrand/tracking';

export const SubscriptionAuthorNameContainer = () => {
  const isSubAgent = useSelector(selectIsSubAgent);
  const agencyName = useSelector(selectAgencyName);
  const agentName = useSelector(selectAgentName);
  const agencyUrl = useSelector(selectAgencyUrl);
  const agentUrl = useSelector(selectAgentUrl);
  const isAgencyHonestIconsShow = useSelector(selectIsHonestIconsShow);

  const name = getName({ isSubAgent, agentName, agencyName });
  const nameUrl = getNameUrl({ isSubAgent, agentUrl, agencyUrl });

  const handleLinkClick = trackGoToAgentCard(isSubAgent ? 'to_realtorCard_sub' : 'to_realtorCard_name');

  return (
    <SubscriptionAuthorName
      name={name}
      nameUrl={nameUrl}
      isAgencyHonestIconsShow={isAgencyHonestIconsShow}
      handleLinkClick={handleLinkClick}
    />
  );
};
